import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = () => {
  // --- AJUSTE ---
  // Se lee el estado de autenticación directamente desde el store de Redux
  // en lugar de usar un selector exportado que ya no existe.
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const authLoading = useSelector((state) => state.auth.isLoading);
  const location = useLocation();

  if (authLoading) {
    // Mientras se verifica el estado de auth, no renderizamos nada o un loader.
    // Esto previene un parpadeo o redirección prematura.
    return null;
  }

  if (!isAuthenticated) {
    // Si no está autenticado, lo redirigimos a la página de login,
    // guardando la ubicación a la que intentaba acceder.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si está autenticado, renderizamos el contenido de la ruta protegida.
  return <Outlet />;
};

export default ProtectedRoute;
